import { Interface, type } from 'implement-js'

export const PathsInterface = Interface('Paths')(
  {
    getScopedPath: type('function'),
    consultantDetailsPath: type('function'),
  },
  { error: true },
)
